export default function HeroSection() {
  const handleClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-20 md:pt-24 pb-16 md:pb-20 overflow-hidden bg-background-50">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none"></div>

      <div className="w-full px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full max-w-2xl">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-semibold mb-5">
              <i className="ri-fire-fill"></i>
              <span>每日更新 · 实时热度追踪</span>
            </div>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              黑料每日大赛
              <span className="block text-primary-600">最新黑料排行榜与大赛排名</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 font-bold mb-4 font-heading">
              劲爆黑料一站式浏览，吃瓜群众首选平台
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl">
              黑料每日大赛是国内领先的娱乐八卦资讯聚合平台，每日追踪全网最热黑料话题，
              涵盖明星动态、综艺内幕、影视剧透等多元内容。AI智能算法结合专业编辑团队，
              确保每一条爆料快速、准确、有深度。当前正值暑期档热度高峰期，
              多个顶流相关话题持续霸榜，吃瓜刻不容缓。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">每日更新500+条</div>
                  <div className="text-xs text-foreground-500">覆盖30+主流平台</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-eye-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">月活3000万+</div>
                  <div className="text-xs text-foreground-500">全网最大吃瓜社区</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-timer-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">热点15分钟响应</div>
                  <div className="text-xs text-foreground-500">重大事件极速上线</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleClick('ranking'); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap text-center"
              >
                查看黑料排行榜 <i className="ri-arrow-right-line ml-1"></i>
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleClick('topics'); }}
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-foreground-200 text-foreground-800 font-semibold rounded-lg hover:border-foreground-400 hover:text-foreground-950 transition-colors text-sm whitespace-nowrap text-center"
              >
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -top-4 -right-4 w-full h-full bg-primary-500/10 rounded-2xl rotate-3"></div>
              <div className="absolute -bottom-4 -left-4 w-full h-full bg-accent-500/10 rounded-2xl -rotate-2"></div>
              <div className="relative rounded-2xl overflow-hidden bg-foreground-900 aspect-[4/5] md:aspect-[5/4] lg:aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Bold%20dramatic%20editorial%20photography%20composition%20with%20warm%20crimson%20red%20and%20dark%20charcoal%20tones%2C%20abstract%20artistic%20representation%20of%20entertainment%20news%20and%20celebrity%20gossip%20culture%2C%20striking%20contrast%20lighting%20with%20deep%20shadows%20creating%20mysterious%20atmosphere%2C%20sophisticated%20magazine-style%20aesthetic%20with%20red%20accent%20glow%20on%20dark%20background%2C%20minimalist%20yet%20powerful%20visual%20impact%2C%20fine%20art%20quality%20with%20cinematic%20lighting&width=800&height=1000&seq=hero-main-01&orientation=portrait"
                  alt="黑料每日大赛 - 最新黑料排行榜与大赛排名主视觉"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2">
                    <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded">实时热度</span>
                    <span className="text-background-50/80 text-xs">7月30日 更新</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}